import { render, staticRenderFns } from "./GlobalHero.vue?vue&type=template&id=77f0ecbd&scoped=true"
import script from "./GlobalHero.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalHero.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalHero.vue?vue&type=style&index=0&id=77f0ecbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f0ecbd",
  null
  
)

export default component.exports